.ef{aspect-ratio:1/1;}